import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const selectKeys = (state: RootState) =>
  state.rootReducer.keysStore.keys;

export const selectIsLoadingKeys = (state: RootState) =>
  state.rootReducer.keysStore.isLoadingKeys;

export const selectKeysState = createSelector(
  selectKeys,
  selectIsLoadingKeys,
  (keys, isLoadingKeys) => ({
    keys,
    isLoadingKeys
  })
);
